export const aggregationTypes = [
    { id: 'DEFAULT', name: 'By data element' },
    { id: 'COUNT', name: 'Count' },
    { id: 'AVERAGE', name: 'Average' },
    { id: 'SUM', name: 'Sum' },
    { id: 'STDDEV', name: 'Standard deviation' },
    { id: 'VARIANCE', name: 'Variance' },
    { id: 'MIN', name: 'Min' },
    { id: 'MAX', name: 'Max' },
];



// WEBPACK FOOTER //
// ./src/constants/aggregationTypes.js